import React from 'react';
import a4logo from '../Images/a4logo.png';
import Sulekha from '../Images/Sulekha.png';
import sumukha from '../Images/sumukha.png';
import madeen from '../Images/madeen.png';
import Truefriend from '../Images/Truefriend.png'
import natural from '../Images/natural.png'
import ismo from '../Images/ismo.png'
import Amided from '../Images/Amided.png'
import sk from '../Images/sk.png'
import acvl from '../Images/acvl.png'
import adhiam from '../Images/adhiam.png'
import rentla from '../Images/rentla.png'
import srealty from '../Images/srealty.jpg';
import sathiymHome from '../Images/sathiymHome.jpeg';

const logos = [
  { id: 1, name: 'A4 Logo', url: a4logo },
  { id: 2, name: 'Sulekha', url: Sulekha },
  // { id: 3, name: 'Sumukha', url: sumukha },
  // { id: 4, name: 'Madeen', url: madeen },
  // { id: 5, name: 'Truefriend', url: Truefriend },
  { id: 6, name: 'srealty', url: srealty },
  // { id: 7, name: 'sathiymHome', url: sathiymHome },
  // { id: 8, name: 'Amided', url: Amided },
  // { id: 9, name: 'SK', url: sk },
  { id: 8, name: 'ACVL', url: acvl },
  { id: 9, name: 'Adhiam', url: adhiam },
  // { id: 10, name: 'Rentla', url: rentla },
]

const LogoSection = () => {
  return (
    <div className="logo-section2">
    <p className="trusted-text">More than 100+ companies trusted us</p>
    <div className="logo-scroll-container">
      {/* Duplicate logos for seamless scroll */}
      <div className="logo-container">
        {logos.concat(logos).map((logo, index) => (
          <div key={index} className="logo-item">
            <img src={logo.url} alt={logo.name} className="logo-image" />
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default LogoSection;
